/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

//手机预览充电点信息
const preview = require('appComp/page/preview/preview/preview');
const previewCom = require('appComp/page/preview/preview');
const plugDetail = require('appComp/page/preview/plug/plugDetail/plugDetail');
const plugComment = require('appComp/page/preview/plug/plugComment/plugComment');
const plugList = require('appComp/page/preview/plug/plugList/plugList');

module.exports = {
    "component":previewCom,
    subRoutes: {
        "/brevity/9999":{
          "component":preview,
           "title":"详情预览",
          "name":"detailpreview"
        },
        "/:id":{
          "component":preview,
           "title":"详情预览",
          "name":"detailpreview"
        },
         "/plugdetails/:id":{
            "component": plugDetail,
            "title":'充电点详情',
            "name":"previewPlugDetail"
        },
        "/plugComment/:id":{
            "component": plugComment,
            "title":'充电点评论',
            "name":"previewPlugComment"
        },
        "/plugList/:id":{
            "component": plugList,
            "title":'充电点车位列表',
            "name":"previewPlugList"
        }
      }
  }



// WEBPACK FOOTER //
// ./src/appBackend/router/preview.js